import URLS from 'config/urls';
import {  type IAdministratorModel } from 'models/user/administrator/entities/AdministratorModel';
import BaseAPI from './BaseApi';
import type { PaginatedResponseModel } from 'models/shared/PaginatedResponseModel';
import type { ErrorModel } from 'models/shared/ErrorModel';
import type { IPermissionModel } from 'models/auth/entities/PermissionModel';


class AdministratorService {
  // Lass
  async getOwnPermissionList(): Promise<IPermissionModel[] | ErrorModel> {
    try {
      const response = await BaseAPI.get(`${URLS.PERMISSIONS}`);
        
      return response.data; // Retorna a resposta da API
    } catch (e) {
      return { error: "Erro ao buscar dados" }; // Retorna um objeto de erro
    }
  }

  async getList(params: any): Promise<PaginatedResponseModel<IAdministratorModel>| ErrorModel> {
    try {
      const response = await BaseAPI.get(`${URLS.USER}/`, { params });
      return response.data; // Retorna a resposta da API
    } catch (e) {
      return { error: "Erro ao buscar dados" }; // Retorna um objeto de erro
    }
  }

  async getAdministratorByUuid(uuid: string): Promise<IAdministratorModel | ErrorModel> {
    try {
      const response = await BaseAPI.get(`${URLS.USER}/${uuid}`);
      return response.data;
    } catch (e) {
      return { error: "Falha ao buscar administrador" };
    }
  }

  async createAdministrator(data: IAdministratorModel): Promise<any> {
    try {
      const response = await BaseAPI.post(`${URLS.USER}/`, data);
      return response;
    } catch (error: any) {
      if (error?.response?.data?.error){
        return { error: error?.response?.data?.error  };
      }
      return { error: "Falha ao cadastrar administrador"  };
    }
  }

  async updateAdministrator(uuid: string, data: IAdministratorModel): Promise<any> {
    try {
      const response = await BaseAPI.put(`${URLS.USER}/${uuid}`, data);
      return response;
    } catch (error: any) {
      if (error?.response?.data?.error){
        return { error: error?.response?.data?.error  };
      }
      return { error: "Falha ao atualizar administrador" };
    }
  }

  async deleteAdministrator(uuid: string): Promise<any> {
    try {
      const response = await BaseAPI.delete(`${URLS.USER}/${uuid}`);
      return response;
    } catch (e) {
      return { error: "Falha ao atualizar administrador" };
    }
  }

  async export(params: any): Promise<any> {
    try {
      const response = await BaseAPI.get(URLS.USER + "/csv", { params });
      return response;
    } catch (e) {
      return { error: "Falha ao gerar csv" };
    }
  }
}

const service = new AdministratorService();
export default service;